// extracted by mini-css-extract-plugin
module.exports = {"form_container":"form-dialog_form_container__3GN_4","form_container_focus":"form-dialog_form_container_focus__2sHHI","text":"form-dialog_text__26mR6"};